export const PaymentStatusType = {
  NotPaid: 0,
  Paid: 1,
  Failed: 2,
  PartiallyPaid: 3,
  Initiated: 4,
  Cancelled: 5,
};
